module.exports = __webpack_public_path__ + "img/cancel.a4caf0d0.svg";